import type { ErrorFallbackProps } from "@circle-react/components/shared/ErrorBoundary";
import { Button } from "@circleco/compass/components/Button";
import { Icon } from "@circleco/compass/components/Icon";
import { Typography } from "@circleco/compass/components/Typography";
import InnerHTML from "dangerously-set-html-content";

import { t } from "@/i18n-js/instance";

export const SearchError = ({ error, resetState }: ErrorFallbackProps) => (
  <div className="m-auto flex max-w-md flex-col items-center justify-center gap-4 p-8 text-center">
    <Icon name="triangle-exclamation-filled" color="danger" size="lg" />
    <Typography variant="body-sm" color="secondary">
      <InnerHTML html={t("search_v2.search_error")} />
    </Typography>
    <Button variant="primary" size="sm" onClick={resetState}>
      {t("search_v2.search_error_retry")}
    </Button>
    {process.env.NODE_ENV === "development" && error.message && (
      <Typography variant="caption" color="tertiary" component="p">
        {error.message}
      </Typography>
    )}
  </div>
);
